import { httpClient } from "@coworker/http-client";
import { FullTask } from "../types/FullTask";

export const getTask = async (taskId: string) => {
  const data = await httpClient.tasks.get<{ tasks: FullTask[] }>(
    `v1/tasks/by_ids`,
    { params: { ids: taskId } }
  );

  const task = data?.tasks[0] ? data.tasks[0] : null;
  return task;
};
